module.exports = __webpack_public_path__ + "img/INF-B-1-II.019ba6c3.png";